export const DeviceStatus = {
    Undeployed: 0,
    Absence: 1,
    Presence: 2,
    NetworkError: 3,
    SensorError: 4,
};
export const MotionStatus = {
    Inactive: 0,
    Active: 1,
    ConnectionError: 2,
};
export const StatusDisplayPriorityOrder = {
    NetworkError: 1,
    SensorError: 2,
    Absence: 3,
    Presence: 4,
    Inactive: 5,
    Unknown: 6,
    Undeployed: 7,
};
export const StatusNameMap = {
    [DeviceStatus.Absence]: 'absent',
    [DeviceStatus.Presence]: 'present',
    [DeviceStatus.NetworkError]: 'network-error',
    [DeviceStatus.SensorError]: 'sensor-error',
    [DeviceStatus.Undeployed]: 'undeployed-error',
};
export const INACTIVE_THRESHOLD_MS = 3 * 24 * 60 * 60 * 1000;
//# sourceMappingURL=device-status.js.map